export var canTouch = 'ontouchstart' in window || window.navigator.maxTouchPoints && window.navigator.maxTouchPoints > 1;
export var pureTouch = ('ontouchstart' in window);